/* ASC-CUSTOM (Atelier design demo, 2026-09-23): small behaviours for the A · Atölye blocks. No dependencies.
   - [data-at-doorby]  "Tue, Oct 6": today + 7 business days (1–3 production + 3–4 delivery, latest end), the same
                       arithmetic as assets/asc-topbar.js, so every page shows one date (docs/PROMISE.md).
   - [data-at-rushby]  "Fri, Oct 2": today + 5 business days (Rush: made in 1 business day, ships the next day,
                       2–3 in transit; spec docs/superpowers/specs/2026-09-25-rush-and-cart-addons-design.md §3.2).
                       Both skip window.ASC_NO_DELIVERY only in the delivery leg. window.ASC_DATES is the math.
   - [data-at-chat]    opens the Shopify Inbox launcher; without it the link goes to the contact page.
   - video[data-at-loop] plays only while on screen; never on reduced motion or Save-Data (the poster stays).
   - [data-at-rot]     rotating product card: 4 s per piece, pauses on hover/focus, dots + progress bar.
   - [data-at-chips]   filter chips over a grid of [data-at-tags] items. */
(function () {
  'use strict';
  var reduce = false, saveData = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}

  /* Business days (Mon–Fri) after `from`. A date listed in `off` ("YYYY-MM-DD", window.ASC_NO_DELIVERY: US carrier
     no-delivery days) is skipped only while the count is inside its last `tail` days, the delivery leg.
     Door-by: 7 days, tail 4. Rush: 5 days, tail 3. Tested in docs/qa/tests/dates.test.js. */
  function dayKey(x) { return x.getFullYear() + '-' + ('0' + (x.getMonth() + 1)).slice(-2) + '-' + ('0' + x.getDate()).slice(-2); }
  function addBiz(from, n, tail, off) {
    var d = new Date(from.getTime()); d.setHours(12, 0, 0, 0);
    var left = n;
    while (left > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6 && !(left <= tail && off.indexOf(dayKey(d)) > -1)) left--; }
    return d;
  }
  window.ASC_DATES = { addBiz: addBiz, dayKey: dayKey };

  function fillDates(sel, date) {
    var nodes = document.querySelectorAll(sel);
    if (!nodes.length) return;
    var txt;
    try { txt = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { txt = date.toDateString().slice(0, 10); }
    Array.prototype.forEach.call(nodes, function (n) {
      n.textContent = txt;
      var wrap = n.closest && n.closest('[data-at-doorby-wrap]');   // lines that only make sense with a date stay hidden without JS
      if (wrap) wrap.removeAttribute('hidden');
    });
  }

  function doorBy() {
    var off = window.ASC_NO_DELIVERY || [], today = new Date();
    fillDates('[data-at-doorby]', addBiz(today, 7, 4, off));
    fillDates('[data-at-rushby]', addBiz(today, 5, 3, off));
  }

  function chat() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-at-chat]');
      if (!a) return;
      /* 2026-10-08: the Inbox button moved one shadow root deeper (shopify-chat > shopify-agent-runtime); the old
         lookup found nothing, so "Open live chat" always fell through to the contact page */
      var c = document.querySelector('shopify-chat');
      var r = c && c.shadowRoot, rt = r && r.querySelector('shopify-agent-runtime');
      var btn = r && (r.querySelector('button.activator') || (rt && rt.shadowRoot && rt.shadowRoot.querySelector('button.activator')) || r.querySelector('button'));
      if (btn) {
        e.preventDefault();
        /* un-hide the bubble where a page keeps it hidden (phone cart), then open it. 2026-10-08: the new Inbox runtime
           closes a panel opened during the same tap (open, then shut ~50 ms later); 300 ms later it stays open */
        document.documentElement.classList.add('at-chat-open');
        setTimeout(function () { btn.click(); }, 300);
      }
    });
  }

  function loops() {
    var vids = document.querySelectorAll('video[data-at-loop]');
    if (!vids.length || reduce || saveData || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '120px' });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  function rotators() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-at-rot]'), function (box) {
      var slides = box.querySelectorAll('[data-at-rot-slide]'), dots = box.querySelectorAll('[data-at-rot-dot]'), bar = box.querySelector('[data-at-rot-bar]');
      var go = box.querySelector('[data-at-rot-go]');
      if (slides.length < 2) return;
      var i = 0, timer = null, paused = false;
      function sync() {
        Array.prototype.forEach.call(slides, function (s, n) { s.classList.toggle('is-on', n === i); s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); });
        Array.prototype.forEach.call(dots, function (d, n) { d.classList.toggle('is-on', n === i); d.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
        if (go) { var u = slides[i].getAttribute('data-url'); if (u) go.setAttribute('href', u); }
      }
      function restartBar() { if (!bar) return; bar.classList.remove('is-run'); void bar.offsetWidth; if (!reduce && !paused) bar.classList.add('is-run'); }
      function show(n) { i = (n + slides.length) % slides.length; sync(); restartBar(); }
      function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, 4000); restartBar(); }
      function stop() { clearInterval(timer); if (bar) bar.classList.remove('is-run'); }
      Array.prototype.forEach.call(dots, function (d, n) { d.addEventListener('click', function () { show(n); if (!paused) start(); }); });
      box.addEventListener('mouseenter', function () { paused = true; stop(); });
      box.addEventListener('mouseleave', function () { paused = false; start(); });
      box.addEventListener('focusin', function () { paused = true; stop(); });
      box.addEventListener('focusout', function () { paused = false; start(); });
      sync(); start();
    });
  }

  function chips() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-at-chips]'), function (bar) {
      var grid = document.getElementById(bar.getAttribute('data-at-chips'));
      if (!grid) return;
      var items = grid.querySelectorAll('[data-at-tags]');
      bar.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-at-filter]');
        if (!b) return;
        var f = b.getAttribute('data-at-filter');
        Array.prototype.forEach.call(bar.querySelectorAll('[data-at-filter]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        Array.prototype.forEach.call(items, function (it) {
          var tags = ' ' + it.getAttribute('data-at-tags') + ' ';
          it.hidden = !(f === 'all' || tags.indexOf(' ' + f + ' ') > -1);
        });
      });
    });
  }

  function init() { doorBy(); chat(); loops(); rotators(); chips(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
